import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { AcCompetenceClickedChartDataType } from '../ac-competence-overview-chart/ac-competence-overview-chart.component';

const BASE_COLOR = '#666666';

export interface AcCompetenceDetailChartDataType {
  name: string;
  values: Array<{[key: number]: number}>;
}

@Component({
  selector: 'app-ac-competence-detail-chart',
  templateUrl: './ac-competence-detail-chart.component.html',
  styleUrls: ['./ac-competence-detail-chart.component.scss']
})
export class AcCompetenceDetailChartComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private chart?: am4charts.XYChart;

  title: string | null = null;

  @Input() data: AcCompetenceClickedChartDataType;
  @ViewChild('chartContainer') chartContainer?: ElementRef = null;

  constructor(private zone: NgZone) {}

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.zone.runOutsideAngular(() => {
      this.chart?.dispose();
    });
  }

  ngOnChanges(): void {
    this.setChartData();
    this.setColor();
  }

  ngAfterViewInit(): void {
    this.renderChart();
  }

  private renderChart(): void {
    this.zone.runOutsideAngular(() => {
      if (this.chartContainer === null) {
        return;
      }
      am4core.useTheme(am4themes_animated);

      const chart = am4core.create(this.chartContainer.nativeElement, am4charts.XYChart);
      chart.height = 450;

      const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'points';
      categoryAxis.renderer.minGridDistance = 20;

      const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;

      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = 'value';
      series.dataFields.categoryY = 'points';

      series.columns.template.adapter.add('fill', (fill, target) => {
        return am4core.color(BASE_COLOR);
      });

      series.columns.template.adapter.add('stroke', (stroke, target) => {
        return am4core.color(BASE_COLOR);
      });

      const valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = '{value}';
      valueLabel.label.fontSize = 14;
      valueLabel.label.adapter.add('dx', (dx, target) => {
        if (!target.dataItem) {
          return dx;
        }
        return (target.dataItem.values.valueY.value <= 1) ? 20 : -20;
      });
      valueLabel.label.adapter.add('fill', (fill, target) => {
        if (!target.dataItem) {
          return fill;
        }
        return (target.dataItem.values.valueY.value === 0) ? am4core.color('#000') : am4core.color('#fff');
      });

      this.chart = chart;
      this.setChartData();
    });
  }

  private setChartData(): void {
    if (this.chart && this.data) {
      this.chart.data = this.data?.data?.sort((a: any, b: any) => {
        return (a.points > b.points) ? 1 : ((b.points > a.points) ? -1 : 0);
      });
    }
  }

  private setColor(): void {
    if (this.chart) {
      const color = (this.data?.color) ? am4core.color(this.data?.color) : am4core.color(BASE_COLOR);
      this.chart.series.each((series: am4charts.ColumnSeries) => {
        series.columns.template.adapter.add('fill', (fill, target) => {
          return color;
        });

        series.columns.template.adapter.add('stroke', (stroke, target) => {
          return color;
        });
      });
    }
  }

}
